import qs from 'qs';
import {
    checkResponseLoggedOut,
    finalizeResponse,
    handleError,
    logError
} from 'tradera/utils/api';
import { touchWebClient } from 'tradera/utils/http';

export function postWishlistItem(itemId, add) {
    return touchWebClient
        .post(add ? `shopping/wishlist/add` : `shopping/wishlist/remove`, {
            itemId
        })
        .then(checkResponseLoggedOut())
        .then(finalizeResponse())
        .catch(handleError())
        .catch((error) => {
            logError(error);
            throw error;
        });
}

export function getItemDiscountQuota() {
    return touchWebClient
        .get('/profile/shop-item-settings/quotas')
        .then(finalizeResponse())
        .catch(handleError())
        .catch((error) => {
            logError(error);
            throw error;
        });
}

export function postItemSettings(itemId, onDisplay, discountRate) {
    const formData = qs.stringify({
        itemId,
        onDisplay,
        discountRate
    });
    return touchWebClient
        .post('/profile/shop-item-settings/settings', formData)
        .then(checkResponseLoggedOut())
        .then(finalizeResponse())
        .catch(handleError())
        .catch((error) => {
            logError(error);
            throw error;
        });
}
